module.exports = __webpack_public_path__ + "assets/img/type_8.8abf9986.png";